export var LayoutSectionParentKey;
(function (LayoutSectionParentKey) {
    LayoutSectionParentKey["CommunityCard"] = "CommunityCard";
    LayoutSectionParentKey["CommunityComparisonTable"] = "CommunityComparisonTable";
    LayoutSectionParentKey["ReferenceContact"] = "ReferenceContact";
    LayoutSectionParentKey["ReferenceBusiness"] = "ReferenceBusiness";
    LayoutSectionParentKey["HostedFormClient"] = "HostedFormClient";
    LayoutSectionParentKey["CommunityDetailsColumn1"] = "CommunityDetailsColumn1";
    LayoutSectionParentKey["CommunityDetailsColumn2"] = "CommunityDetailsColumn2";
    LayoutSectionParentKey["ReferralCommunityCard"] = "ReferralCommunityCard";
})(LayoutSectionParentKey || (LayoutSectionParentKey = {}));
export var NaryFormat;
(function (NaryFormat) {
    NaryFormat["OnePerLine"] = "OnePerLine";
    NaryFormat["SemicolonSeparated"] = "SemicolonSeparated";
})(NaryFormat || (NaryFormat = {}));
export const NaryFormatLabels = {
    [NaryFormat.OnePerLine]: "Display one item per line",
    [NaryFormat.SemicolonSeparated]: "Display as semicolon separated list",
};
export var LayoutSectionLegacyPerspective;
(function (LayoutSectionLegacyPerspective) {
    LayoutSectionLegacyPerspective["Client"] = "Client";
    LayoutSectionLegacyPerspective["Community"] = "Community";
})(LayoutSectionLegacyPerspective || (LayoutSectionLegacyPerspective = {}));
export var LayoutSectionSettingType;
(function (LayoutSectionSettingType) {
    LayoutSectionSettingType["Boolean"] = "Boolean";
})(LayoutSectionSettingType || (LayoutSectionSettingType = {}));
export var LayoutSectionKey;
(function (LayoutSectionKey) {
    LayoutSectionKey["CommunityCardKeyAttributes"] = "CommunityCardKeyAttributes";
    LayoutSectionKey["CommunityComparisonCommunityRow"] = "CommunityComparisonCommunityRow";
    LayoutSectionKey["CommunityComparisonNotesRow"] = "CommunityComparisonNotesRow";
    LayoutSectionKey["CommunityComparisonDistanceRow"] = "CommunityComparisonDistanceRow";
    LayoutSectionKey["CommunityComparisonSummaryRow"] = "CommunityComparisonSummaryRow";
    LayoutSectionKey["CommunityComparisonPrimaryContactRow"] = "CommunityComparisonPrimaryContactRow";
    LayoutSectionKey["CommunityComparisonToursRow"] = "CommunityComparisonToursRow";
    LayoutSectionKey["CommunityComparisonCommunityTypeRow"] = "CommunityComparisonCommunityTypeRow";
    LayoutSectionKey["CommunityComparisonFinanceRow"] = "CommunityComparisonFinanceRow";
    LayoutSectionKey["CommunityComparisonStaffRow"] = "CommunityComparisonStaffRow";
    LayoutSectionKey["CommunityComparisonHealthServicesRow"] = "CommunityComparisonHealthServicesRow";
    LayoutSectionKey["CommunityComparisonActivitiesRow"] = "CommunityComparisonActivitiesRow";
    LayoutSectionKey["CommunityComparisonOtherDetailsRow"] = "CommunityComparisonOtherDetailsRow";
    LayoutSectionKey["CommunityComparisonAmenitiesRow"] = "CommunityComparisonAmenitiesRow";
    LayoutSectionKey["CommunityComparisonPhotosRow"] = "CommunityComparisonPhotosRow";
    LayoutSectionKey["CommunityComparisonCommunityRecordsRow"] = "CommunityComparisonCommunityRecordsRow";
    LayoutSectionKey["ReferenceContactContactInformation"] = "ReferenceContactContactInformation";
    LayoutSectionKey["ReferenceContactAdditionalInformation"] = "ReferenceContactAdditionalInformation";
    LayoutSectionKey["ReferenceBusinessContactInformation"] = "ReferenceBusinessContactInformation";
    LayoutSectionKey["ReferenceBusinessAdditionalInformation"] = "ReferenceBusinessAdditionalInformation";
    LayoutSectionKey["HostedFormClientBestContact"] = "HostedFormClientBestContact";
    LayoutSectionKey["HostedFormClientClient"] = "HostedFormClientClient";
    LayoutSectionKey["HostedFormClientOther"] = "HostedFormClientOther";
    LayoutSectionKey["CommunityDetailsCommunityInfo"] = "CommunityDetailsCommunityInfo";
    LayoutSectionKey["CommunityDetailsCommunityContacts"] = "CommunityDetailsCommunityContacts";
    LayoutSectionKey["CommunityDetailsNotes"] = "CommunityDetailsNotes";
    LayoutSectionKey["CommunityDetailsPhotos"] = "CommunityDetailsPhotos";
    LayoutSectionKey["ReferralCommunityCardKeyAttributes"] = "ReferralCommunityCardKeyAttributes";
})(LayoutSectionKey || (LayoutSectionKey = {}));
export const isCustomSection = (key) => {
    return key.toLowerCase().startsWith("custom_");
};
export var SectionRenderBehaviorType;
(function (SectionRenderBehaviorType) {
    SectionRenderBehaviorType["None"] = "None";
    SectionRenderBehaviorType["Custom"] = "Custom";
    SectionRenderBehaviorType["SingleProperty"] = "SingleProperty";
    SectionRenderBehaviorType["LayoutItems"] = "LayoutItems";
    SectionRenderBehaviorType["CustomWithLayoutItems"] = "CustomWithLayoutItems";
    SectionRenderBehaviorType["Notes"] = "Notes";
})(SectionRenderBehaviorType || (SectionRenderBehaviorType = {}));
//# sourceMappingURL=layout-item.js.map